export interface ImageTilePlan {
  index: number;
  count: number;
  sourceY: number;
  sourceHeight: number;
}

const MAX_TILE_HEIGHT = 3200;
const TILE_OVERLAP = 160;
const MAX_OUTPUT_WIDTH = 1400;
const LABEL_HEIGHT = 56;

export function planLongImageTiles(
  width: number,
  height: number,
): ImageTilePlan[] {
  if (height < 5000 && height <= width * 3.5) return [];
  const count = Math.ceil(
    (height - TILE_OVERLAP) / (MAX_TILE_HEIGHT - TILE_OVERLAP),
  );
  if (count <= 1) return [];
  const sourceHeight = Math.ceil((height + (count - 1) * TILE_OVERLAP) / count);
  const step = sourceHeight - TILE_OVERLAP;
  return Array.from({ length: count }, (_, index) => ({
    index,
    count,
    sourceY: index * step,
    sourceHeight: index === count - 1 ? height - index * step : sourceHeight,
  }));
}

async function loadImage(source: string): Promise<HTMLImageElement> {
  const image = new Image();
  image.src = source;
  await image.decode();
  return image;
}

export async function prepareImageForModel(source: string): Promise<string[]> {
  const image = await loadImage(source);
  const tiles = planLongImageTiles(image.naturalWidth, image.naturalHeight);
  if (!tiles.length) return [source];

  return tiles.map((tile) => {
    const scale = Math.min(1, MAX_OUTPUT_WIDTH / image.naturalWidth);
    const outputWidth = Math.round(image.naturalWidth * scale);
    const outputHeight = Math.round(tile.sourceHeight * scale);
    const canvas = document.createElement("canvas");
    canvas.width = outputWidth;
    canvas.height = outputHeight + LABEL_HEIGHT;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("浏览器无法处理长截图");
    context.fillStyle = "#17211d";
    context.fillRect(0, 0, outputWidth, canvas.height);
    context.fillStyle = "#f4f7f5";
    context.font = "24px sans-serif";
    context.textBaseline = "middle";
    context.fillText(
      `长截图第 ${tile.index + 1} / ${tile.count} 段 · 按时间从上到下`,
      20,
      LABEL_HEIGHT / 2,
    );
    context.drawImage(
      image,
      0,
      tile.sourceY,
      image.naturalWidth,
      tile.sourceHeight,
      0,
      LABEL_HEIGHT,
      outputWidth,
      outputHeight,
    );
    return canvas.toDataURL("image/jpeg", 0.88);
  });
}
